import React, { useState, useEffect, useContext } from "react";
import { useLocation } from 'react-router-dom';
import API_BASE_URL from '../Config';
import { Link } from "react-router-dom";
import { LocationContext } from "./LocationContext";

function Header({ onCategoryClick, onSubCategoryClick }) {
    // const { location, status } = useContext(LocationContext);
    console.log("======================= header");
    // const navigate = useNavigate();

    const [categories, setCategories] = useState([]);
    const location = useLocation();
    const [isCategoriesOpen, setIsCategoriesOpen] = useState(true);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [open, setOpen] = useState(false);
    const [selectedSubcategory, setSelectedSubcategory] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [isFJSpecial, setIsFJSpecial] = useState(false);

    const locationContext = useContext(LocationContext);

    if (!locationContext) {
        throw new Error("Header must be wrapped inside LocationProvider");
    }

    const { status, errorMessage, address } = locationContext;

    
    useEffect(() => {


        const token = localStorage.getItem("token");
        if (token) {
            setIsLoggedIn(true);
        }
        
        // Fetch categories
        fetch(`${API_BASE_URL}/api/categories-with-subcategories-for-dashboard`)
        .then((res) => res.json())
        .then((data) => {
            console.log("categories-for-dashboard===============");
            console.log(data);
            if (data.status === 1) {
            setCategories(data.response.categories);
            }
        });

        // Check if it's a mobile device
        const isMobile = window.innerWidth <= 767;
        // Only keep menu open on home page and only on desktop
        setIsCategoriesOpen(!isMobile && location.pathname === '/');
    }, [location.pathname]);
    
    const toggleCategories = () => {
        setIsCategoriesOpen(!isCategoriesOpen);
    };


    const handleCategoryClick = (catId) => {
        setSelectedCategory(catId); // update selected subcategory
        // onCategoryClick(catId);
        setOpen(false)
    };
    
    const handleSubCategoryClick = (catId, subId) => {
        setSelectedSubcategory(subId); // update selected subcategory
        onSubCategoryClick(catId, subId);
        setOpen(false);
    };

    const handleLogout = () => {
        const token = localStorage.getItem("token");        
        try {
            fetch(`${API_BASE_URL}/api/logout`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Token ${token}`,
                },
            })
            .then((res) => res.json())
            .then((data) => {
                console.log(data);
                if (data.status === 1) {
                    localStorage.removeItem("token");
                    setIsLoggedIn(false);
                    // optional: redirect to home
                    window.location.href = "/";
                }
            })
            .catch((err) => {
                console.error(err);
            });
        } catch (err) {
            console.error(err);
        }      
    };

    return (
        <div>
            <div className="off_canvars_overlay"></div>
            <div className="offcanvas_menu offcanvas6">

                <div className="container">
                    <div className="row">
                    {location.pathname === '/' && (
                        <div className="col-12">
                            
                            <div className="canvas_open">
                            <button
                                type="button"
                                className="bg-transparent border-0"
                                onClick={() => setOpen(true)}
                            >
                                <i className="icon-menu" />
                            </button>
                            </div>
                            
                                
                            <div className={`offcanvas_menu_wrapper ${open ? "active" : ""}`} style={{ display: open ? "block" : "none" }}>
                            <div className="canvas_close">
                                <button type="button" className="bg-transparent border-0" onClick={() => setOpen(false)}>
                                    <i className="icon-x" />
                                </button>
                            </div>

                            <div className="language_currency">
                                <ul>
                                    <li className="language">
                                        <a href="/about"> About</a>
                                    </li>
                                    <li className="currency">
                                        <a href="/contact"> Contact</a>
                                    </li>
                                </ul>
                            </div>

                            <div className="header_social text-right">
                                <ul>
                                    <li><a href="#"><i className="ion-social-youtube-outline" /></a></li>
                                    <li><a href="#"><i className="ion-social-facebook" /></a></li>
                                    <li><a href="#"><i className="ion-social-instagram-outline" /></a></li>
                                </ul>
                            </div>

                            <div className="call-support">
                                <p><a href="tel:(08)23456789">(08) 23 456 789</a> Customer Support</p>
                            </div>
                            

                            <div id="menu" className="text-left">

                                <ul className="offcanvas_main_menu">
                                    {categories.map((cat) => (
                                        <li className="menu-item-has-children" key={cat.id}>
                                        <a
                                            href="#" onClick={(e) => {
                                            e.preventDefault();
                                            handleCategoryClick(cat.id); 
                                            }}
                                        >
                                            {cat.name} <i className="fa fa-angle-down" />
                                        </a>

                                        {/* Subcategories dropdown */}
                                        {cat.sub_categories && cat.sub_categories.length > 0 && (
                                            <ul className="sub-menu">
                                                {cat.sub_categories.map((sub) => (
                                                <div key={sub.id}>
                                                    <li>
                                                        <a href="#"
                                                            onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation(); 
                                                            handleSubCategoryClick(cat.id, sub.id); 
                                                            }}
                                                        >
                                                            {sub.name}
                                                        </a>
                                                    </li>
                                                </div>
                                                ))}
                                            </ul>
                                        )}
                                        </li>
                                    ))}
                                </ul>

                            </div>
                            
                            <div className="offcanvas_footer">
                                <span>
                                <a href="#"><i className="fa fa-envelope-o" /> info@yourdomain.com</a>
                                </span>
                            </div>

                            </div>
                        </div>
                    )}
                    </div>
                </div>
    
            </div>
           
            <header>
                <div className="main_header container_width color_six p-0">
                <div className="header_top header_top_bg">
                    <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-4 col-md-4">
                        <div className="language_currency">
                            <ul>
                                <li className="language"><a href="/about"> About</a>
                                
                                </li>
                                <li className="currency"><a href="/contact"> Contact</a>
                                </li>
                            </ul>
                        </div>
                        </div>

                        <div className="col-lg-4 col-md-4 text-white">
                            <i className="fa fa-map-marker"></i> {address}
                        </div>

                        <div className="col-lg-4 col-md-4">
                            <div className="header_social text-right">
                                <ul>
                                    <li><a href="https://www.youtube.com/@findmejoinme"><i className="ion-social-youtube-outline" /></a></li>
                                    <li><a href="https://www.facebook.com/findmejoinme"><i className="ion-social-facebook" /></a></li>
                                    <li><a href="https://www.instagram.com/findmejoinme"><i className="ion-social-instagram-outline" /></a></li>
                                    <li><a href="https://www.tiktok.com/@findmejoinme"><i className="fab fa-tiktok" /></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
                <div className="header_middle header_middle6 border-bottom">
                    <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-2 col-md-2 col-sm-2 col-2">
                        <div className="logo">
                            {/* <a href="/"><img src="/assets/img/logo/logo.png" alt /></a> */}
                            <a href="/"><img src="/assets/images/fj-logo.png" width='30' height='30' alt="Logo" /></a>

                        </div>
                        </div>

                        <div className="col-lg-2 col-md-2 col-sm-2 col-2">
                           
                        </div>

                        <div className="col-lg-4 col-md-4 col-sm-4 col-4">
                           {/* <i className="fa fa-map-marker"></i> {address} */}
                        </div>

                        <div className="col-lg-4 col-md-4 col-sm-4 col-4">
                        <div className="header_right_info">
                            <div className="search_container mobail_s_none">
                            
                            </div>
                            <div className="header_account_area">
                            <div className="header_account_list register">
                                {isLoggedIn ? (
                                    <ul>
                                        <li><a href="#" onClick={handleLogout}>Logout</a></li>
                                    </ul>
                                ) : (
                                    <ul>
                                        <li><a href="/login">Register</a></li>
                                        <li><span>/</span></li>
                                        <li><a href="/login">Login</a></li>
                                    </ul>
                                )}
                            </div>
                            
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                
                
                    <div className="header_bottom sticky-header border-bottom">
                        <div className="container">  
                        <div className="row align-items-center">
                            <div className="col-lg-12">
                                {/*main menu start*/}
                                <div className="main_menu menu_position"> 
                                    <nav>  
                                        <ul>    
                                            {/* <li className={isFJSpecial ? "selected" : ""}>
                                                <a href="/fj-special" onClick={() => {
                                                            setIsFJSpecial(true);
                                                            setSelectedCategory(null);
                                                            setSelectedSubcategory(null);
                                                        }}
                                                    >
                                                    FJ Special
                                                    </a>
                                            </li> */}


                                            <li className={isFJSpecial ? "selected" : ""}>
                                                <Link
                                                    to="/fj-special"
                                                    onClick={() => {
                                                    setIsFJSpecial(true);
                                                    setSelectedCategory(null);
                                                    setSelectedSubcategory(null);
                                                    }}
                                                >
                                                    FJ Special
                                                </Link>
                                                </li>
                                            
                                            {categories.map(cat => (
                                                <li key={cat.id} className={selectedCategory === cat.id ? "selected" : ""}>
                                                    <Link
                                                        to={`/category/${cat.id}`}
                                                        onClick={() => {
                                                            setSelectedCategory(cat.id);
                                                            setIsFJSpecial(false);
                                                            setSelectedSubcategory(null);
                                                        }}
                                                    >
                                                        {cat.name} <i className="fa fa-angle-down" />
                                                    </Link>

                                                    <ul className="sub_menu home_sub_menu row">
                                                        {cat.sub_categories.map(sub => (
                                                            <li
                                                                key={sub.id}
                                                                className={`col-md-3 ${selectedSubcategory === sub.id ? "selected" : ""}`}
                                                            >
                                                                <Link
                                                                    to={`/category/${cat.id}/sub/${sub.id}`}
                                                                    onClick={() => {
                                                                        setSelectedCategory(cat.id);
                                                                        setIsFJSpecial(false);
                                                                        setSelectedSubcategory(sub.id);
                                                                    }}
                                                                >
                                                                    {sub.name}
                                                                </Link>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </li>
                                            ))}

                                        </ul> 
                                    </nav> 
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                            
                </div> 
            </header>
        </div>

    );
}

export default Header;